import React from "react";
import { coverThemeFor } from "@/lib/churchCover";

// Themed default church cover (gradient + subtle cross watermark + light bloom).
// Used everywhere a church has no uploaded cover photo, so cards stay distinct.
export const ChurchCoverFallback = ({ church, className = "", testId }) => {
  const theme = coverThemeFor(church);
  return (
    <div
      className={`overflow-hidden ${className}`}
      style={{ background: theme.gradient }}
      data-testid={testId || `church-cover-theme-${church?.id || "x"}`}
      aria-hidden="true"
    >
      <div
        className="absolute inset-0"
        style={{ background: "radial-gradient(120% 120% at 78% 24%, rgba(255,255,255,0.24), transparent 55%)" }}
      />
      <svg viewBox="0 0 24 24" className="absolute -right-2 -bottom-3 h-24 w-24" style={{ opacity: 0.16 }}>
        <path d="M10.5 2h3v5h4.5v3H13.5v12h-3V10H6V7h4.5z" fill="#fff" />
      </svg>
    </div>
  );
};

export default ChurchCoverFallback;
